import { reactLocalStorage } from 'reactjs-localstorage';

function get(key, defaultValue = undefined, silent = true) {
  if (isLocalStorageAvailable()) {
    return reactLocalStorage.get(key, defaultValue, silent);
  } else {
    return undefined;
  }
}

function set(key, value) {
  if (isLocalStorageAvailable()) {
    reactLocalStorage.set(key, value);
  }
}

function getObject(key, defaultValue = {}, silent = true) {
  if (isLocalStorageAvailable()) {
    return reactLocalStorage.getObject(key, defaultValue, silent);
  } else {
    return undefined;
  }
}

function setObject(key, object) {
  if (isLocalStorageAvailable()) {
    return reactLocalStorage.setObject(key, object);
  }
  return undefined;
}

function isLocalStorageAvailable() {
  var test = 'test';
  try {
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
}

const failsaveStorage = {
  get,
  set,
  getObject,
  setObject,
};

export default failsaveStorage;
